<template>
  <el-select
    ref="select"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder||undefined"
    filterable
    multiple
    clearable
    class="cargo-project-name-select"
    @input="onInput"
  >
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :value="item"
    />
  </el-select>
</template>

<script>
import { getProjectNames } from '@/api/projectManage/project'

// 项目名称
let projectNames = null

export default {
  name: 'CargoProjectNameSelect',
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' }
  },
  data() {
    return {
      options: []
    }
  },
  watch: {
    value() {
      this.convertSelectedToText()
    }
  },
  async created() {
    if (!projectNames) {
      await getProjectNames().then(res => {
        projectNames = res.data
      })
    }
    this.options = projectNames
    this.convertSelectedToText()
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    convertSelectedToText() {
      this.$nextTick(() => {
        const curSelect = this.$refs.select
        console.log('select', curSelect)
        const selected = curSelect.selected.map(item => {
          return item.$el ? item.$el.innerText.trim() : ''
        })
        const tagWrapper = curSelect.$el.querySelector('.el-select__tags>span')
        const childs = tagWrapper.childNodes
        if (childs.length > 1) {
          for (let i = 0; i < childs.length; ++i) {
            if (childs[i].className.includes('el-tag--info')) {
              childs[i].style.display = 'none'
            }
          }
          if (selected.length > 0) {
            if (childs[0].className !== '') {
              const newSpan = document.createElement('span')
              newSpan.innerText = `${selected.join(',')}`
              tagWrapper.insertBefore(newSpan, tagWrapper.childNodes[0])
            } else {
              childs[0].innerText = `${selected.join(',')}`
            }
          } else {
            tagWrapper.innerHTML = '<span></span>'
          }
        } else {
          tagWrapper.innerHTML = selected.length ? `<span>${selected.join(',')}</span>` : '<span></span>'
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-select.cargo-project-name-select {
  .el-select__tags {
    flex-wrap: nowrap;
      > span {
        width: auto;
        max-width: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        padding-left: 8px;
        font-size: 12px;
        color: #606266;
        & > span {
          padding-left: 0;
          padding-right: 5px;
          width: 100%;
        }
      }
      input.el-select__input {
        margin-left: 1px;
      }
  }
}
</style>
